$(function () {
  if (!$('body').hasClass('neos-backend')) {
    $('.parallax-section').parallax();
  }
})
